import type { Spritesheet } from "pixi.js";
import { loadGameVisualAssets, type GameVisualAssets } from "../assets/GameVisualAssets";
import { COMPOSITION_ROOT, GAME_LOGO, GameScene } from "./GameScene";
import { GameModals } from "./GameModals";
import type { GameSceneHandle, SceneDeps } from "@slot/game-shell";

/** This game's scene as the shell sees it, plus what its round presentation reads. */
export interface BloodyTeddyScene extends GameSceneHandle {
  game: GameScene;
  gameModals: GameModals;
  /** The symbols atlas (the win look resolves its alt frames from it). */
  symbolsAtlas: Spritesheet;
  /** Every loaded piece of art (the features build their views from it). */
  assets: GameVisualAssets;
}

/** The scene and the game modals from the loaded assets (the art layout is this game's). */
export function createScene(deps: SceneDeps): BloodyTeddyScene {
  const assets = loadGameVisualAssets({ payload: deps.payload, log: deps.log });
  const game = new GameScene({
    assets,
    chromeTaskRunner: deps.services.chromeTaskRunner,
    featureStateStore: deps.services.featureStateStore,
    viewport: deps.viewport,
    contentArea: deps.contentArea,
    spineDriver: deps.spineDriver,
    log: deps.log,
  });
  const gameModals = new GameModals({
    assets,
    localization: deps.services.localization,
    runner: deps.services.chromeTaskRunner,
    viewport: deps.viewport,
    spineDriver: deps.spineDriver,
  });
  return {
    node: game,
    modalsNode: gameModals,
    compositionRoot: game.compositionRoot,
    compositionSize: { width: COMPOSITION_ROOT.width, height: COMPOSITION_ROOT.height },
    logo: GAME_LOGO,
    game,
    gameModals,
    symbolsAtlas: assets.symbols,
    assets,
  };
}
